import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { adminProductApi } from '../../../../api/adminProductApi';
import { readProductListQuery, toProductFilterParams } from '../productListQuery';
import { getApiErrorText } from '../../../../utils/apiResponse';
import { toggleValue } from './mobileProductUtils';

export default function useMobileProductSelection(products) {
  const history = useHistory();
  const [ids, setIds] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const mounted = useRef(false);
  const locked = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const allOnPage = products.length > 0 && products.every(product => ids.includes(product.id));
  const toggle = id => {
    if (!locked.current) setIds(prev => toggleValue(prev, id));
  };
  const togglePage = () => {
    if (locked.current) return;
    const pageIds = products.map(product => product.id);
    setIds(prev =>
      allOnPage ? prev.filter(id => !pageIds.includes(id)) : [...new Set([...prev, ...pageIds])],
    );
  };
  const selectMatching = async () => {
    if (locked.current) return;
    locked.current = true;
    setBusy(true);
    setError('');
    const search = history.location.search;
    try {
      const response = await adminProductApi.getProductIds(
        toProductFilterParams(readProductListQuery(search)),
      );
      if (!mounted.current) return;
      if (history.location.search !== search) {
        setError('Фільтри змінилися. Повторіть вибір товарів.');
        return;
      }
      if (!Array.isArray(response.data.ids)) throw new Error('Не вдалося отримати ID товарів');
      setIds(prev => [...new Set([...prev, ...response.data.ids])]);
    } catch (err) {
      if (mounted.current) setError(getApiErrorText(err, 'Не вдалося обрати товари'));
    } finally {
      locked.current = false;
      if (mounted.current) setBusy(false);
    }
  };
  return {
    ids,
    busy,
    error,
    allOnPage,
    someOnPage: products.some(product => ids.includes(product.id)),
    toggle,
    togglePage,
    selectMatching,
    clear: () => {
      if (!locked.current) setIds([]);
    },
  };
}
